import DisplayAdvertising from '@propertypal/web-ui/src/products/DisplayAdvertising';
import ProductsContact from '@propertypal/web-ui/src/products/ProductsContact';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../../../components/layout/MetaTags';

const metaData = {
  title: 'Agents Display Advertising - PropertyPal',
  description: 'Build Your Brand And Extend Your Reach To An Audience Very Specific To You.',
  url: `/products/estate-agents/display-advertising`,
};

const AgentDisplayAdvertising = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <DisplayAdvertising />
      <ProductsContact reason="Agents Display Advertising" />
    </>
  );
};

export default AgentDisplayAdvertising;
